export * from './aliases.component';
export * from './alias';
